// =========================================================================
//  Community Categories — 새로운 13개 대카테고리 + 서브카테고리 매핑
//  Lucide icon name 문자열을 사용 (sidebar에서 동적 import 처리)
// =========================================================================

export const CATEGORIES = [
  {
    id: "home",
    label: "홈",
    icon: "Home",
    isFeed: true,
    topics: null, // null = 전체
  },
  {
    id: "notice",
    label: "공지",
    icon: "Megaphone",
    description: "운영팀의 공지사항을 확인하세요",
    isFeed: true,
    adminOnly: true, // 글 작성은 관리자만 (읽기는 모두 가능)
  },
  {
    id: "intro",
    label: "가입인사",
    icon: "HandHeart",
    description: "새로 오신 분들의 첫 인사를 나누는 공간이에요",
    isFeed: true,
  },
  {
    id: "relationships",
    label: "연애와 사랑",
    icon: "Heart",
    isFeed: true,
    hideInSidebar: true,
    sub: [
      { id: "sseom", label: "썸" },
      { id: "remarriage", label: "재혼" },
      { id: "love_counsel", label: "연애상담" },
      { id: "psychology", label: "남녀심리" },
      { id: "loneliness", label: "외로움" },
      { id: "breakup", label: "이별" },
    ],
    // 기존 감성 토픽 흡수
    legacy: ["lonely_night", "midlife_love"],
  },
  {
    id: "travel",
    label: "여행",
    icon: "Plane",
    isFeed: true,
    hideInSidebar: true,
    sub: [
      { id: "domestic", label: "국내여행" },
      { id: "abroad", label: "해외여행" },
      { id: "food", label: "맛집" },
      { id: "travel_mate", label: "여행메이트" },
      { id: "camping", label: "캠핑/차박" },
    ],
  },
  {
    id: "health",
    label: "건강",
    icon: "Activity",
    isFeed: true,
    hideInSidebar: true,
    sub: [
      { id: "exercise", label: "운동" },
      { id: "diet", label: "다이어트" },
      { id: "menopause", label: "갱년기" },
      { id: "supplement", label: "영양제" },
      { id: "healing", label: "힐링/명상" },
    ],
  },
  {
    id: "hobby",
    label: "취미",
    icon: "Palette",
    isFeed: true,
    hideInSidebar: true,
    sub: [
      { id: "golf", label: "골프" },
      { id: "hiking", label: "등산" },
      { id: "music", label: "음악" },
      { id: "movie", label: "영화" },
      { id: "reading", label: "독서" },
      { id: "wine", label: "와인" },
      { id: "photo", label: "사진" },
    ],
  },
  {
    id: "retirement",
    label: "노후 & 인생2막",
    icon: "Wallet",
    isFeed: true,
    hideInSidebar: true,
    sub: [
      { id: "retirement_plan", label: "은퇴" },
      { id: "finance", label: "재테크" },
      { id: "realestate", label: "부동산" },
      { id: "startup", label: "창업" },
      { id: "overseas", label: "해외살이" },
    ],
    legacy: ["global_korean"],
  },
  {
    id: "free",
    label: "자유게시판",
    icon: "Coffee",
    isFeed: true,
    hideInSidebar: true,
    sub: [
      { id: "today", label: "오늘의 일상" },
      { id: "emotional", label: "감성글" },
      { id: "solo_meal", label: "혼밥" },
      { id: "diary", label: "일기 느낌 글" },
    ],
    // 기존 감성 토픽 다수 흡수 (today_feeling은 '오늘의 하루'가 소유)
    legacy: ["today_question", "someones_story", "liz_words", "todays_empathy"],
  },
  {
    id: "today_moment",
    label: "오늘의 하루",
    icon: "Camera",
    description: "Threads 느낌의 짧은 글 + 사진",
    isFeed: true,
    legacy: ["today_feeling"],
  },
  {
    id: "contact",
    label: "문의하기",
    icon: "MessageSquare",
    description: "운영팀에 문의/건의하거나 궁금한 점을 남겨주세요",
    isFeed: true,
  },
  // 가입 후기 작성/열람 (피드 카테고리)
  { id: "review", label: "가입후기", icon: "Star", description: "New Coupling 가입 후기를 남겨주세요", isFeed: true },
];

// 카테고리 ID → 모든 토픽(서브카테고리 + 레거시 흡수 포함) 리스트로 변환
export function topicsForCategory(catId) {
  const cat = CATEGORIES.find((c) => c.id === catId);
  if (!cat || !cat.isFeed) return null;
  if (catId === "home") return null; // 전체
  const subs = (cat.sub || []).map((s) => s.id);
  const legacy = cat.legacy || [];
  // 카테고리 ID 자체도 토픽으로 사용 가능
  const own = [cat.id];
  return [...new Set([...own, ...subs, ...legacy])];
}

// 서브카테고리는 자체 ID + (선택적으로) 레거시 일부
export function topicsForSub(subId) {
  return [subId];
}

// 토픽 → 카테고리/서브카테고리 라벨 (게시물 카드 표시용)
const LABEL_MAP = (() => {
  const m = {};
  CATEGORIES.forEach((c) => {
    if (!c.isFeed) return;
    m[c.id] = { label: c.label, cat: c.id, sub: null };
    (c.sub || []).forEach((s) => {
      m[s.id] = { label: s.label, cat: c.id, sub: s.id };
    });
    (c.legacy || []).forEach((lid) => {
      if (!m[lid]) m[lid] = { label: c.label, cat: c.id, sub: null };
    });
  });
  return m;
})();

export function labelForTopic(topicId) {
  return LABEL_MAP[topicId]?.label || topicId || "이야기";
}

// 토픽 → 상위 카테고리 ID (매거진 홈에서 섹션별 버킷팅용)
export function categoryForTopic(topicId) {
  return LABEL_MAP[topicId]?.cat || null;
}

// My Profile 사이드바 서브항목 (받은 관심은 AdmirersCard로 상단 별도 노출)
export const MY_PROFILE_ITEMS = [
  { id: "ai_friends", label: "AI가 추천한 친구", icon: "Sparkles", href: "/my-posts?tab=ai" },
  { id: "comment_alerts", label: "댓글알림", icon: "MessageCircle", href: "/comment-notifications" },
  { id: "messages", label: "메시지함", icon: "Mail", href: "/messages" },
  { id: "chat", label: "채팅", icon: "MessageSquare", href: "/chat" },
  { id: "my_posts", label: "내 글 모아보기", icon: "FileText", href: "/my-posts" },
];

export const FEED_TABS = [
  { id: "discover", label: "둘러보기" },
  { id: "latest", label: "최신" },
  { id: "popular", label: "인기" },
  { id: "essay", label: "L양의 연애 에세이" },
];
